import { Skin } from '@emoji-mart/data'
import { emojiData, categoryIdToLegacyCategoryName } from '@manychat/generate-emoji'

const convertSurrogate = (s: string) => {
  const sn = parseInt(s, 16)
  if (sn >= 0x10000 && sn <= 0x10ffff) {
    const hi = Math.floor((sn - 0x10000) / 0x400) + 0xd800
    const lo = ((sn - 0x10000) % 0x400) + 0xdc00
    return [hi.toString(16).toUpperCase(), lo.toString(16).toUpperCase()]
  } else {
    return false
  }
}

const getUnicode = ({ unified }: Skin) => {
  const unicode = unified
    .split('-')
    .map((c) => {
      if (c.length <= 4) {
        return '\\u' + c
      }

      const surrogates = convertSurrogate(c)

      return surrogates === false ? '' : '\\u' + surrogates[0] + '\\u' + surrogates[1]
    })
    .join('')

  return '(?=[^\\u200d])' + unicode + '(?=[^\\u200d])'
}

const regexData = Object.values(emojiData.emojis)
  .map(({ skins }) => skins)
  .flat()
  .map(getUnicode)

export const emojiRegExp = new RegExp('(' + regexData.join('|') + ')', 'g')

export const defaultCategoryIds = Object.keys(categoryIdToLegacyCategoryName)

export const getEmojiLegacyCategoryName = (id: string) => {
  const category = emojiData.categories
    .filter((category) => defaultCategoryIds.includes(category.id))
    .find((category) => category.emojis.includes(id))

  if (!category) {
    return ''
  }

  return categoryIdToLegacyCategoryName[category.id]
}

export const hasEmojiSupport = () => {
  const winVersion = (navigator || window.navigator)?.userAgent
    ?.match(/.*Windows NT [\d\.]*/)?.[0]
    ?.replace(/.*Windows NT ([\d\.]*)/, '$1')

  if (!winVersion) {
    return true
  }

  return parseFloat(winVersion) > 6.1
}
